import React from "react";
import AdminHeader from "./AdminHeader";
import AdminNavbar from "./AdminNavbar";
import { Link } from "react-router-dom";
const AblockMarket = () => {
  return (
    <div>
      <AdminHeader />
      <AdminNavbar />
      <div className="commision fixed_width h-[100vh]  bg-[#f0ece1]  ">
        <div className="flex-col flex justify-center ">
          <h2 className="font-bold mt-4  text-black px-[50px]">
            Sport Listing
          </h2>
          <div className="flex flex-col">
            <div className="overflow-x-auto flex justify-center">
              <div className="p-1.5 w-[95%] inline-block align-middle">
                <div className="overflow-hidden border border-black">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-300 text-black">
                      <tr>
                        <th
                          scope="col"
                          colSpan="2"
                          className="px-6 py-3 text-xs font-bold text-left  uppercase "
                        >
                          S.No.
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-xs font-bold text-left  uppercase "
                        >
                          Betfair ID
                        </th>
                        <th
                          scope="col"
                          colSpan="1"
                          className="px-4 py-3 text-xs font-bold text-left  uppercase "
                        >
                          Name
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-xs font-bold text-left  uppercase "
                        >
                          Status
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-xs font-bold text-right  uppercase "
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y bg-[#fff] divide-gray-200">
                      {[1, 2, 3, 4, 5, 6].map(() => {
                        return (
                          <tr>
                            <td className="px-6 py-4 text-sm font-medium text-gray-800 whitespace-nowrap">
                              3
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-800 whitespace-nowrap">
                              Jone Doe
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-800 whitespace-nowrap">
                              1
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-800 whitespace-nowrap">
                              <a href="#"> Cricket</a>
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-800 whitespace-nowrap">
                              Soccer in On
                            </td>
                            <td
                              colSpan="4"
                              className="px-6 py-4 text-sm font-medium text-right whitespace-nowrap"
                            >
                              <input
                                class="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-neutral-300 before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-neutral-100 after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-primary checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgba(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-primary checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:bg-neutral-600 dark:after:bg-neutral-400 dark:checked:bg-primary dark:checked:after:bg-primary dark:focus:before:shadow-[3px_-1px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca]"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckDefault"
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      ;
    </div>
  );
};

export default AblockMarket;
